import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { useHistory } from "react-router-dom";
import api from "../../api"
import { toast } from "react-toastify";
import cross from "../../assets/images/icon/cross.svg";
function UploadModal({ show, handleUpdationClose, message, user_id }) {
  const history = useHistory();
  const [errors, setErrors] = useState({});
  const [statePayload, setStatePayload] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const handleResumeUpload = event => {
    const file = event.target.files[0];
    console.log("File:::", file);
    const allowedExtensions = /(\.doc|\.docx|\.pdf)$/i;
    if (!allowedExtensions.exec(file?.name)) {
      setErrors(prevState => ({
        ...prevState,
        resume: "Only PDF, DOC, and DOCX are allowed.",
      }));
      return;
    }

    // Setting the resume file;
    setStatePayload(prevState => ({
      ...prevState,
      resume: file,
    }));
  };

  const updateResume = (payload, user_id) => {
    api
      .patch(
        `${process.env.REACT_APP_API_URL}/admin/common/update-resume/${user_id}`,
        payload,
      )
      .then(response => {
        setIsLoading(false);
        handleUpdationClose();
        toast.success("Resume Uploaded Successfully");
        history.push("/pending-list");
      })
      .catch(err => {
        setIsLoading(false);
        handleUpdationClose();
        toast.error("Resume Uploaded Successfully");
        console.log("Error:", err);
      });
  };

  const handleSubmit = event => {
    event.preventDefault();
    setErrors({});
    setIsLoading(true);

    // Setting payload to save inside the database;
    let payload = new FormData();
    payload.append("resume", statePayload?.resume);
    console.log("Form Data Payload::", payload); // Log payload for debugging

    // Calling the API and saving data;
    updateResume(payload, user_id);
  };

  useEffect(() => {
    if (show) {
      const timeout = setTimeout(() => {
        const modalBackdrop = document.querySelector(".modal-backdrop");
        if (modalBackdrop) {
          modalBackdrop.classList.add("edit-cksisjs");
        }
      }, 10); // Adjust the delay as necessary

      return () => clearTimeout(timeout);
    }
  }, [show]);

  return (
    <div className="edit-modal">
      <Modal
        show={show}
        onHide={handleUpdationClose}
        className="edit-modal-card"
      >
        {/* <Modal.Header closeButton>
          <Modal.Title>{message}</Modal.Title>
        </Modal.Header> */}
        <Modal.Body>
          <div className="filters-cards-cross">
            <div className="filter-content">
              <h4>{message}</h4>
            </div>
            <div className="filter-content cross" onClick={handleUpdationClose}>
              <img src={cross} alt="" />
            </div>
          </div>
          <div className="bordertops"></div>
          <Form className="form-modal">
            <Form.Group>
              <Form.Label className="pb-2">
                Only JPG, JPEG, DOC, DOCX, PNG, and PDF file types, with size
                less than 10MB are allowed. <span></span>
              </Form.Label>
              <AvForm>
                <AvField
                  type="file"
                  className="form-control"
                  id="resume"
                  name="resume"
                  errorMessage="Resume is required"
                  placeholder=" "
                  accept=".pdf, .doc, .docx"
                  validate={{ required: { value: true } }}
                  onChange={handleResumeUpload}
                  title={`Please upload  file`}
                />
              </AvForm>
              {errors.resume && (
                <span className="text-danger">{errors.resume}</span>
              )}
            </Form.Group>

            <div className="serach-btn modal-action-btn text-center mt-4  d-flex gap-3">
              <button
                className="btn btn-primary reset"
                onClick={handleUpdationClose}
              >
                Cancel
              </button>
              <Button variant="primary" onClick={handleSubmit}>
                Submit
              </Button>
            </div>
          </Form>
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleUpdationClose}>
            Cancel
          </Button>
        </Modal.Footer> */}
      </Modal>
    </div>
  );
}

export default UploadModal;
